import * as yup from 'yup'
import { t } from 'i18next'

export const FeedbackFormSchema = yup.object({
  message: yup.string().required(t('general.validation.required')),
  mood: yup.object().required(t('general.validation.required'))
})
